<ng-container *ngIf="!workflow">
	<nz-page-header [nzTitle]="'My ' + ticketMode + 's'" nzSubtitle="Choose workflow"></nz-page-header>

	<div class="workflow-grid">
		<nz-card *ngFor="let wf of workflows" [nzTitle]="wf.name" class="workflow-card c-title" (click)="selectWorkflow(wf)" nzHoverable>
			<p class="description">{{ wf.description }}</p>
			<button nz-button nzType="primary" class="select-btn">Select</button>
		</nz-card>
	</div>

</ng-container>

<ng-container *ngIf="workflow">
	<div class="workflow-heading text-center">
		<h2 class="m-0">{{ workflow.label }}</h2>
	</div>

	<nz-steps
		nzDirection="horizontal"
		nzLabelPlacement="vertical"
		[nzCurrent]="currentStepIndex"
		(nzIndexChange)="onStepIndexChange($event)"
  		class="pointer-steps step-wrap mb-3">
		<nz-step *ngFor="let step of workflow.steps; let i = index" [nzTitle]="title">
			<ng-template #title>{{step.label}} ({{step.ticketCount}})</ng-template>
		</nz-step>
	</nz-steps>


	<div class="row">
		<div class="col">
			<nz-page-header [nzTitle]="step!.label"></nz-page-header>
		</div>
		<ng-container *ngIf="agents">
			<div class="col-3" *hasPermission="['TicketAdmin']">
				<nz-select class="float-end" style="width: 300px" nzShowSearch nzPlaceHolder="Search agent" [ngModel]="selectedAgent" [nzFilterOption]="filterOption" (ngModelChange)="onSelect($event)" >
					<nz-option [nzValue]="undefined" [nzLabel]="'All Users'"></nz-option>
					<nz-option [nzValue]="getAuthedAgent()" [nzLabel]="'My ' + ticketMode + 's'"></nz-option>
					<nz-option nzDisabled="true" nzLabel="──────────"></nz-option>
					<nz-option *ngFor="let agent of agents" [nzLabel]="agent.firstName + ' ' + agent.lastName" [nzValue]="agent"></nz-option>
				</nz-select>
			</div>
		</ng-container>
	</div>
<!--
	<div class="row">
		<div class="col">
			<div class="filters mb-3 d-flex align-items-center gap-2 justify-content-end">
				<nz-input-group [nzSize]="'large'" style="max-width: 260px; width: 100%;">
					<input nz-input placeholder="Search tickets..." [(ngModel)]="searchText" (keyup.enter)="search()" />
				</nz-input-group>
				<button nz-button nzType="primary" nzSize="large" (click)="search()" nzIgnoreDefault>
					Search
				</button>
			</div>
		</div>
	</div> -->

	<nz-table
		#ticketsTable
		[nzBordered]="true"
		[nzLoading]="loading"
		[nzData]="tickets"
		[nzFrontPagination]="false"
		[nzTotal]="total"
		[nzPageSize]="pageSize"
		[nzPageIndex]="pageIndex"
		[nzShowSizeChanger]="true"
		[nzPageSizeOptions]="[5, 10, 15, 20, 25, 50, 100]"
		(nzQueryParams)="onQueryParamsChange($event, getThis())">
		<thead>
			<tr>
				<th>Ref</th>
				<th>FAO</th>
				<th *ngIf="isShowTicketReferenceColumn">Ticket Reference</th>
				<th>Member Details</th>
				<th *ngIf="isShowMembershipColumn">Membership Number</th>
				<th>Category</th>
				<th>Status</th>
				<th>Action</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let ticket of tickets; let i = index" class="cursor-pointer" (dblclick)="openTicket(ticket)">
				<td>{{ ticket.ticketReference }}</td>
				<td>{{ ticket.assignedToAgent?.firstName }} {{ ticket.assignedToAgent?.lastName }}</td>
				<td *ngIf="isShowTicketReferenceColumn">{{ ticket.id }}</td>
				<td>{{ ticket.member.name }} {{ ticket.member.surname }}</td>
				<td *ngIf="isShowMembershipColumn">{{ ticket.membership?.membershipNumber??'-' }}</td>
				<td>{{ ticket.membership?.category??'-' }}</td>

				<td class="p-0">
					<nz-alert [nzBanner]="true" [nzType]="getSlaClass(ticket)" [nzDescription]="ticket.currentStepAndStateLabel"></nz-alert>
				</td>

				<td *hasPermission="['TicketAdmin']">
					<button nz-button *ngIf="!ticket.assignedToAgent" (click)="showAssignTicketToAgentPopup(ticket)">Assign</button>
					<button nz-button *ngIf="ticket.assignedToAgent" (click)="showAssignTicketToAgentPopup(ticket)">Reassign</button>
				</td>
				<td *withoutPermission="['TicketAdmin']">
					<ng-container *ngIf="!ticket.assignedToAgent">
						<button nz-button (click)="assignTicketToThisAgent(ticket)">Assign To Me</button>
					</ng-container>
					&nbsp;
				</td>
			</tr>
		</tbody>
	</nz-table>
</ng-container>
